import { useEffect, useState } from 'react';
import { resolveImage } from "../../images/ImageResolver";
import WealthPackages from './WealthPackages';
import { fetchData, styles, renderPreText, textWithColor } from './Helpers';

export default function Packages() {
  const [wealth, setWealth] = useState(false);
  const [fullData, setFullData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData("Ownership").then((res) => {
      setFullData(res);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    const grid = document.getElementById('grid');
    const columns = [
      { name: 'CATEGORY', field: 'category', scalable: true, leftPinned: true, binding: textWithColor },
      { name: 'REDISTRIBUTION', field: 'public', scalable: true, headerBinding: headerWithLink.bind(null, "Free to air", "free"), styles: styles, binding: renderPreText },
      { name: 'REDISTRIBUTION', field: 'private', scalable: true, headerBinding: headerWithLink.bind(null, "PW Protected", "private"), binding: renderPreText },
      { name: 'FINANCIAL PROFESSIONAL', field: 'professional', scalable: true, headerBinding: headerWithLink.bind(null, "Internal Use", "professional"), styles: styles, binding: renderPreText },
    ];

    function gridConfigured(e) {
      const core = e.detail.api.getCoreGrid();
      core.setColumnWidths([250, 500, 500, 500], false);
    }

    function headerWithLink(text, i, e) {
      let cell = e.cell;
      let content = cell.getContent();
      if(!content || !content._myHeaderWithLink) {
        content = document.createElement("div");
        content._myHeaderWithLink = true;
        let span = content._span = document.createElement("span");
        span.style.marginRight = "5px";
        let link = content._link = document.createElement("ef-icon");
        link.icon = "link";
        content.addEventListener("click", function(arg) {
          arg.stopPropagation();
          setWealth(true);
        });
        let image = content._span1 = document.createElement("img");
        image.style.position = "absolute";
        image.style.top = "10px";
        image.style.right = "5px";
        image.style.width = "38px";
        image.src = resolveImage(i);
        let span2 = content._span2 = document.createElement("span");
        span2.style.display = "block";
        span2.style.fontWeight = 400;
        content.appendChild(span);
        content.appendChild(link);
        content.appendChild(span2);
        content.appendChild(image);
      }

      content._span.textContent = e.columnDef.getName();
      content._span2.textContent = text;
      cell.setContent(content);
    };

    if(!wealth){
      grid.config = {
        rowHeight: 140,
        headerRowHeight: 60,
        autoHideScrollbar: false,
        columns: columns,
        dataModel: {
          data: fullData
        }
      }; 
      grid.addEventListener('configured', gridConfigured);
    }

  }, [fullData, wealth]);

  return (
    <div className='main-div'>
      <ef-loader class="loader" hidden={!loading}></ef-loader>
      {wealth && (
        <div>
          <ef-button className="back-button" icon="back" onClick={() => setWealth(false)}>Back</ef-button>
          <WealthPackages />
        </div>
      )}
      {!wealth && (
        <div id='loadingMask_div'>
          <h4>Ownership</h4>
          <p>Clients can only be permissioned with the Global Package. Clients control application access by region.</p>
          <efx-grid id="grid" className="ownership-grid"></efx-grid>
        </div>
      )}
    </div>
  );
}